type RideForTbd = {
  flexibleRide?: boolean | null;
  driver?: { isPlaceholder?: boolean | null } | null;
};

/**
 * Whether a flexible ride's pickup time should be displayed as "TBD".
 *
 * Flexible rides are stored with a placeholder pickup time (11:59 PM — when Uber
 * expires the ride if the rider never texts "1" to confirm). The real pickup
 * time only exists once a real, non-placeholder driver is assigned.
 *
 * This mirrors the backend rule used everywhere else
 * (NotificationTextGenerator#when_time): show "TBD" for any flexible ride that
 * does not yet have a real driver assigned — regardless of ride status.
 */
export const flexibleRidePickupTimeTbd = (ride: RideForTbd): boolean => {
  const realDriverAssigned = ride.driver != null && !ride.driver.isPlaceholder;
  return Boolean(ride.flexibleRide) && !realDriverAssigned;
};
